import { createFileRoute } from "@tanstack/react-router";
import { AppLayout } from "@/components/app-layout";
import { FileText } from "lucide-react";

export const Route = createFileRoute("/questionnaire")({
  head: () => ({
    meta: [
      { title: "Questionnaire Designer — AskBell" },
      { name: "description", content: "AI-powered questionnaire design tool" },
    ],
  }),
  component: QuestionnairePage,
});

function QuestionnairePage() {
  return (
    <AppLayout>
      <div className="flex-1 flex flex-col items-center justify-center text-center p-8">
        <div className="flex h-16 w-16 items-center justify-center rounded-ui-md bg-lime/10 text-lime mb-4">
          <FileText className="h-8 w-8" />
        </div>
        <h1 className="text-ui-2xl font-bold text-foreground mb-2">Questionnaire Designer</h1>
        <p className="text-ui-base text-muted-foreground max-w-md mb-6">
          Drop in a spec, proposal, or SOW and get a ready-made questionnaire designed in Bellomy's
          preferred format — powered by AI and your library of past questionnaires.
        </p>
        <div className="inline-flex items-center gap-2 rounded-full bg-secondary px-4 py-2 text-ui-sm font-bold text-muted-foreground">
          Coming soon
        </div>
      </div>
    </AppLayout>
  );
}
